import React from 'react';

import { Typography, Box, Divider, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useAppSelector } from 'hooks';

import UpdatePasswordForm from 'components/user/UpdatePasswordForm';
import UpdateEmailPreferecesForm from 'components/user/UpdateEmailPreferecesForm';
import StandardPage from 'components/StandardPage';

interface Props {}

const OwnProfilePage: React.FunctionComponent<Props> = ({}) => {
    const theme = useTheme();

    const { auth } = useAppSelector((state) => state);

    const user = auth.user.object;

    return (
        <StandardPage
            title="User Profile"
            breadcrumbs={[
                { text: 'Home', link: '/' },
                { text: 'User Profile' },
            ]}
            maxWidth="xl"
        >
            {user && (
                <Box
                    sx={{
                        backgroundColor: theme.palette.common.neutralXXLight,
                        borderRadius: 1,
                        p: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h4">{user.fullName}</Typography>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {user.isSuperuser && (
                                <Chip label="System Admin" color="info" />
                            )}
                            {!user.isActive && (
                                <Chip label="User Disabled" color="error" />
                            )}
                            {user.groups.map((group) => (
                                <Chip label={group} key={group} />
                            ))}
                        </Box>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplate: '1fr 1fr / auto auto',
                        }}
                    >
                        <Typography variant="subtitle1">Username:</Typography>
                        <Typography variant="subtitle1">
                            {user.userName}
                        </Typography>

                        <Typography variant="subtitle1">Email:</Typography>
                        <Typography variant="subtitle1">
                            {user.email}
                        </Typography>

                        <Typography variant="subtitle1">
                            Organisation
                            {user.organisation_set?.length > 1 ? 's' : ''}:
                        </Typography>
                        <Typography variant="subtitle1">
                            {user.organisation_set
                                .map((org) => org.name)
                                .join(', ')}
                        </Typography>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: 2,
                        }}
                    >
                        <UpdatePasswordForm />
                        <UpdateEmailPreferecesForm />
                    </Box>
                </Box>
            )}
        </StandardPage>
    );
};

OwnProfilePage.displayName = 'OwnProfilePage';
export default OwnProfilePage;
